import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { NavController, Platform } from "@ionic/angular";
import { Subscription } from 'rxjs';
import { TreeNode } from 'src/model/class/general classes/tree-node';
import { TreeGatewayTag } from 'src/model/enum/enumTagGatewayTree';
import { EventService } from 'src/service/event.service';


@Component({
    selector: 'app-tree-node',
    templateUrl: './tree-node.component.html',
    styleUrls: ['./tree-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TreeNodeComponent implements OnInit, OnDestroy {
  @Input('nodes') nodes: TreeNode[]; //nodes structure to draw  

  private _currentSelection: TreeNode[] = [];
  public TreeGatewayTag = TreeGatewayTag;
  private _subscriptions : Subscription[] = [];
  constructor(public platform: Platform, public nav: NavController, private _eventService: EventService) {

  }

  ngOnDestroy(): void {
    for (let s = 0; s < this._subscriptions.length; s++) {
      this._subscriptions[s].unsubscribe();
    }
  }

  /**
   * Subscribe on events: click node of building treee and change name of object associated to the current node
   */
  ngOnInit() {    
    this._subscriptions.push(this._eventService.OnGatewayBuildingNodeSelected.subscribe((nodes: TreeNode[]) => {      
      this._currentSelection = nodes;
      for (let n = 0; n < this.nodes.length; n++) {
        for (let nselected = 0; nselected < nodes.length; nselected++) {
          this.nodes[n].isSelected =  this.nodes[n].id == nodes[nselected].id && this.nodes[n].tag == nodes[nselected].tag;
          if (this.nodes[n].isSelected)
            break;
        }            
      }
    }));

    this._subscriptions.push(this._eventService.OnGatewayBuildingNodeInfoChanged.subscribe((node:TreeNode) => {
      for (let n = 0; n < this.nodes.length; n++) {
        if (this.nodes[n].id == node.id && this.nodes[n].tag == node.tag) {
          this.nodes[n].title = node.title;
        }
      }
    }));

    this._subscriptions.push(this._eventService.OnGatewayBuildingNodeDeleted.subscribe((node: TreeNode[]) => {
      for (let n = 0; n < this.nodes.length; n++) {
        for (let i = 0; i < node.length; i++) {
          if (this.nodes[n].id == node[i].id && this.nodes[n].tag == node[0].tag) {
            this.nodes.splice(n, 1);
          }
        }        
      }
    }))

    // find parent node and add the new created node
    this._subscriptions.push(this._eventService.OnGatewayBuildingNodeAdded.subscribe((nodes: TreeNode[]) => { 
      if (nodes[0] != null) {
        for (let n = 0; n < this.nodes.length; n++) {        
          if (this.nodes[n].id == nodes[0].id && this.nodes[n].tag == nodes[0].tag) {          
            this.nodes[n].sub.push(nodes[1]);
          }             
        }
      }
    }));
  }

  /**
   * Open the sub node (or close it) and send the selection of the nodes
   * @param event 
   * @param node 
   */
  clickNode(event: PointerEvent, node) {
    if (!event.ctrlKey)
      this._eventService.OnGatewayBuildingNodeSelected.next([node]);
    else 
      this._eventService.OnGatewayBuildingNodeSelected.next([...this._currentSelection, node]);
  }

  /**
   * Clicking on arrow near the node expand or reduce a node
   * @param node 
   */
  expandNode(node) {
    if (!node.sub && node.url) {
      //NODE IS A CHILD --> open Page Component in data model, passing the node such as parameter.
      this.nav.navigateForward([node.url, { node: JSON.stringify(node) }]);
    }
  }

  
}
